import typing from "./typing";
export default typing;


// WEBPACK FOOTER //
// /src/call/container/typing/index.js